import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtmlTags'
})
export class StripHtmlTagsPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }
    // Use a regular expression to replace HTML tags with an empty string
    return value.replace(/<[^>]*>/g, '');
  }
}
